export const AD_DETAIL_PAGE_SECTION_PRICE_ID = 'price'
export const AD_DETAIL_PAGE_SECTION_FEATURES_ID = 'features'
export const AD_DETAIL_PAGE_SECTION_DESCRIPTION_ID = 'description'
export const AD_DETAIL_PAGE_SECTION_TRUST_ID = 'trust'
export const AD_DETAIL_PAGE_SECTION_ADVANTAGES_ID = 'advantages'
export const AD_DETAIL_PAGE_SECTION_FINANCING_ID = 'financing'
export const AD_DETAIL_PAGE_SECTION_SELLER_ID = 'seller'
export const AD_DETAIL_PAGE_SECTION_FINANCING_LEGAL_CONDITIONS_ID = 'financing-legal-conditions'

export const AD_DETAIL_PAGE_SECTION_IDS = {
  PRICE: AD_DETAIL_PAGE_SECTION_PRICE_ID,
  FEATURES: AD_DETAIL_PAGE_SECTION_FEATURES_ID,
  DESCRIPTION: AD_DETAIL_PAGE_SECTION_DESCRIPTION_ID,
  TRUST: AD_DETAIL_PAGE_SECTION_TRUST_ID,
  ADVANTAGES: AD_DETAIL_PAGE_SECTION_ADVANTAGES_ID,
  FINANCING: AD_DETAIL_PAGE_SECTION_FINANCING_ID,
  SELLER: AD_DETAIL_PAGE_SECTION_SELLER_ID,
  FINANCING_LEGAL_CONDITIONS: AD_DETAIL_PAGE_SECTION_FINANCING_LEGAL_CONDITIONS_ID
}

export const AD_DETAIL_PAGE_SECTIONS_ORDER = [
  AD_DETAIL_PAGE_SECTION_PRICE_ID,
  AD_DETAIL_PAGE_SECTION_FEATURES_ID,
  AD_DETAIL_PAGE_SECTION_DESCRIPTION_ID,
  AD_DETAIL_PAGE_SECTION_TRUST_ID,
  AD_DETAIL_PAGE_SECTION_ADVANTAGES_ID,
  AD_DETAIL_PAGE_SECTION_FINANCING_ID,
  AD_DETAIL_PAGE_SECTION_SELLER_ID
]

export const AD_DETAIL_PAGE_SECTIONS_HIDDEN_FOR_SUBSCRIPTION_IDS = [
  AD_DETAIL_PAGE_SECTION_FINANCING_ID,
  AD_DETAIL_PAGE_SECTION_ADVANTAGES_ID
]

// Values agreed in the tagging plan for the "Detail Navbar Clicked" event's hit_information field.
export const AD_DETAIL_PAGE_SECTION_TRACKING_HIT_INFORMATIONS = {
  [AD_DETAIL_PAGE_SECTION_PRICE_ID]: 'price',
  [AD_DETAIL_PAGE_SECTION_FEATURES_ID]: 'features',
  [AD_DETAIL_PAGE_SECTION_DESCRIPTION_ID]: 'description',
  // 'trust' section id maps to 'certification' hit_information — naming diverges intentionally per tagging plan.
  [AD_DETAIL_PAGE_SECTION_TRUST_ID]: 'certification',
  // 'advantages' section id maps to 'benefits' hit_information — same intentional divergence.
  [AD_DETAIL_PAGE_SECTION_ADVANTAGES_ID]: 'benefits',
  [AD_DETAIL_PAGE_SECTION_FINANCING_ID]: 'financing',
  [AD_DETAIL_PAGE_SECTION_SELLER_ID]: 'seller'
}
